import * as React from 'react';
export const ServerContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=ServerContext.js.map